<template>
  <div>
    <div class="content">
      <div class="row mb-4">
        <div class="col-md-8">
          <Titulo
            title="Editar Vidas"
            description="Alteração de dados, troca de planos ou acomodações ou cancelamentos de vidas"
          />
        </div>
        <div class="col-md-4 text-left text-md-right mt-2 mt-md-0">
          <Botao
            :title="'INCLUIR NOVA VIDA'"
            :link="`/produto/cdl-saude-plano/planos?tipoCadastro=${
              list.length === 0 ? 'titular' : 'dependente'
            }`"
            :nameClass="'btn btn-success'"
            >INCLUIR DEPENDENTE</Botao
          >
        </div>
      </div>
      <Lista :list="list" @remover="removerItem" @editar="editarItem" />
      <Loading v-if="list.length === 0" />
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          link="/produto/cdl-saude-plano/listavidas"
          name-class="btn btn-outline-secondary btn-lg btn-block"
        >
          Voltar
        </Botao>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import Lista from "@/components/vidas/ListaVidasAtivas";
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "AlterarPlano",
  components: { Loading, Lista, Titulo, Botao },
  data() {
    return {
      disable: true,
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Editar Vidas",
          id: "editar_cadastros",
        },
      ],
      values: {},
      atualizar: 0,
      list: [],
      registros: [],
    };
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  mounted() {
    this.getRegistros();
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return valor ? formatter.format(valor) : "-";
    },
  },
  methods: {
    async getRegistros() {
      var result = [];
      if (this.urlParams.cpfVida) {
        await this.$http
          .get(
            `/api/CdlBh/ConsultarSamVidaArta?cpfTitular=${this.urlParams.cpfVida}`
          )
          .then((response) => {
            result = response.data.lista;
            const dadosInclusao = [
              {
                vidaAtiva: true,
                tipoCadastro: "titular",
                plano: {
                  codPlano: result[0].codplanofx,
                },
                cadastroFinal: {
                  cpf: result[0].cpF_TITULAR,
                },
              },
            ];

            localStorage.setItem(
              "cdlsaude_cadastro",
              JSON.stringify(dadosInclusao)
            );
          });

        this.list = [];
        this.totalMensalidade = 0;
        result.forEach((e) => {
          result.push(...e.dependentes);
        });

        result.forEach((e) => {
          var statusVida = null;
          var opcionais = "";
          var listActions = "";
          e.listaOpcional.forEach((op) => {
            opcionais = opcionais
              ? opcionais + ", " + op.opcional
              : op.opcional;
          });

          if (e.status === "VIDA") {
            listActions = [
              {
                label: "Trocar acomodação",
                link: "/produto/cdl-saude-plano/trocaracomodacao/" + e.codvida,
                icon: "edit",
                disabled: e.operadora === "UNIMED BH" ? false : true,
              },
              {
                label: "Atualizar Opcionais",
                link: "/produto/cdl-saude-plano/opcional/" + e.codvida,
                icon: "edit",
                disabled: false,
              },
              {
                label: "Cancelar",
                link: "/produto/cdl-saude-plano/cancelamento/" + e.codvida,
                icon: "edit",
                disabled: false,
              },
            ];
          } else {
            if (e.linkdrive === "" || e.statuschamado == "Reprovado") {
              listActions = [
                {
                  label: "Enviar Arquivos",
                  link: "/produto/cdl-saude-plano/documentos/" + e.cpF_TITULAR,
                  icon: "edit",
                },
              ];
            } else {
              if (e.statuschamado === "Em Atendimento") {
                listActions = [
                  {
                    label: "Aguardando Validação",
                    link: "/produto/cdl-saude-plano",
                    icon: "edit",
                    disabled: true,
                  },
                ];
                statusVida = "Aguardando Validação";
              } else if (
                e.statuschamado === "Aprovado" &&
                e.statuS_PAGARME === " "
              ) {
                listActions = [
                  {
                    label: "Efetuar Pagamento",
                    link: "/produto/cdl-saude-plano/pagamento/" + e.cpF_TITULAR,
                    icon: "edit",
                  },
                ];
              }
            }
          }

          this.list.push({
            info: {
              name: {
                label: e.cpF_DEPENDENTE === "" ? "Titular" : "Dependente",
                value: e.nome,
              },
              document: {
                label: "CPF",
                value:
                  e.cpF_DEPENDENTE === "" ? e.cpF_TITULAR : e.cpF_DEPENDENTE,
              },
              plano: {
                label: "Plano",
                value:
                  e.operadora +
                  ", " +
                  e.assistencia +
                  " (" +
                  e.acomodacao +
                  ")",
              },
              acomodacao: {
                label: "Acomodação",
                value: e.acomodacao,
              },
              opcionais: {
                label: "Opcionais",
                value: opcionais,
              },
              preco: {
                label: "Valor unitário",
                value: e.valorplano ?? 0,
              },
              status: statusVida,
            },
            actions: listActions,
          });
        });
      }

      sessionStorage.setItem("alterPlano", JSON.stringify(result));
    },
    removerItem(id) {
      this.$delete(this.registros, id);
      const parsed = JSON.stringify(this.registros);
      localStorage.setItem("cdlsaude_cadastro", parsed);
      this.getRegistros();
    },
    editarItem(id) {
      this.registros.forEach((data, index) => {
        if (index == id) {
          this.$router.push({
            name: "planos",
            query: { id: id, tipoCadastro: data.tipoCadastro },
          });
        }
      });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    sessionStorage.removeItem("trocaOpcionais");
  },
};
</script>
